import { useEffect, useMemo } from "react";
import { useGLTF } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import * as THREE from "three";

export default function Stairway({
  position = [-8.53, 28, 11.95],
  rotation = [0, 0, 0],
  scale = 1,
  color = "#4DE284",
  ...rigidBodyProps
}) {
  const { scene } = useGLTF("/stairway.glb");
  const stairwayScene = useMemo(() => scene.clone(true), [scene]);
  const desiredColor = useMemo(() => new THREE.Color(color), [color]);

  useEffect(() => {
    const recolorMaterial = (material) => {
      if (!material) return material;
      const cloned = material.clone?.() ?? material;
      if (cloned?.color) {
        cloned.color.copy(desiredColor);
      }
      return cloned;
    };

    stairwayScene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.receiveShadow = true;
        if (child.material) {
          child.material = Array.isArray(child.material)
            ? child.material.map((entry) => recolorMaterial(entry))
            : recolorMaterial(child.material);
        }
      }
    });
  }, [desiredColor, stairwayScene]);

  return (
    <RigidBody
      type="fixed"
      colliders="trimesh"
      position={position}
      rotation={rotation}
      {...rigidBodyProps}
    >
      <group scale={scale}>
        <primitive object={stairwayScene} />
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/stairway.glb");
